/* ══════════════════════════════════════════
   LUXIRE v2 — Quick Order from Collection
   Shows profile-based add-to-cart on product cards
   when a matching measurement profile exists.
   ══════════════════════════════════════════ */
(function() {
  'use strict';

  var STORE_KEY = 'luxire_account_hub';

  function getStore() {
    return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getAccountHub() : {};
  }

  function getMeasProfiles() {
    return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getMeasurementProfilesSync() : [];
  }
  function getStyleProfiles() {
    return (typeof LuxireStorage !== 'undefined') ? LuxireStorage.getStyleProfilesSync() : [];
  }

  /* Which measurement key prefixes does a garment type need? */
  var GARMENT_MEAS_PREFIX = {
    trouser: ['trouser_'],
    shirt:   ['shirt_'],
    jacket:  ['jacket_'],
    suit:    ['trouser_', 'jacket_', 'shirt_']  /* any of these qualifies */
  };

  /* Check if a measurement profile has relevant data for a garment type */
  function profileMatchesGarment(profile, garmentType) {
    var m = profile.measurements || {};
    var prefixes = GARMENT_MEAS_PREFIX[garmentType] || [];
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var keys = Object.keys(m);
      for (var j = 0; j < keys.length; j++) {
        if (keys[j].indexOf(prefix) === 0 && m[keys[j]]) return true;
      }
    }
    return false;
  }

  /* Build the hidden property map from a measurement profile */
  var MEAS_KEY_MAP = {
    shirt_neck: 'Neck', shirt_chest: 'Chest', shirt_waist: 'Shirt Waist', shirt_hips: 'Shirt Hips',
    shirt_shoulder: 'Shoulder', shirt_sleeve: 'Sleeve Length', shirt_bicep: 'Bicep', shirt_wrist: 'Wrist',
    shirt_front_length: 'Shirt Front Length', shirt_back_length: 'Shirt Back Length',
    shirt_yoke: 'Yoke Width', shirt_elbow: 'Elbow',
    trouser_waist: 'Pant Waist', trouser_seat: 'Pant Hip', trouser_front_rise: 'Pant Front Rise',
    trouser_back_rise: 'Pant Back Rise', trouser_thigh: 'Pant Thigh', trouser_mid_thigh: 'Pant Mid Thigh',
    trouser_knee: 'Pant Knee', trouser_bottom: 'Pant Bottom Opening',
    trouser_inseam: 'Pant Inseam', trouser_outseam: 'Pant Outseam',
    trouser_calf: 'Pant Calf', trouser_crotch_width: 'Crotch Width',
    jacket_chest: 'Jacket Chest', jacket_waist: 'Jacket Waist',
    jacket_shoulder: 'Jacket Shoulder', jacket_length: 'Jacket Length',
    jacket_sleeve: 'Jacket Sleeve', jacket_half_back: 'Half Back Width',
    jacket_bicep: 'Jacket Bicep', jacket_front_length: 'Jacket Front Length',
    body_height: 'Height', body_weight: 'Weight',
    fit_notes: 'Fit Notes', ref_orders: 'Reference Orders'
  };

  function buildMeasProperties(profile) {
    var props = {};
    var m = profile.measurements || {};
    Object.keys(m).forEach(function(key) {
      if (!m[key]) return;
      var propName = MEAS_KEY_MAP[key] || key.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
      props[propName] = m[key];
    });
    return props;
  }

  function buildStyleProperties(profile) {
    var props = {};
    var s = profile.styles || {};
    Object.keys(s).forEach(function(key) {
      if (!s[key]) return;
      var propName = key.replace(/^(shirt_|trouser_|jacket_|suit_)/, '').replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
      props[propName] = s[key];
    });
    return props;
  }

  function init() {
    var bars = document.querySelectorAll('[data-qo-bar]');
    if (!bars.length) return;

    var measProfiles = getMeasProfiles();
    var styleProfiles = getStyleProfiles();
    if (measProfiles.length === 0) return; /* No profiles = no quick order */

    bars.forEach(function(bar) {
      var garmentType = bar.dataset.garmentType;
      var isBasic = bar.dataset.isBasic === 'true';

      /* Find matching measurement profiles */
      var matchingMeas = [];
      measProfiles.forEach(function(p, i) {
        if (profileMatchesGarment(p, garmentType)) {
          matchingMeas.push({ profile: p, idx: i });
        }
      });

      if (matchingMeas.length === 0) return; /* No matching profiles for this garment */

      /* Populate measurement dropdown */
      var measSelect = bar.querySelector('[data-qo-meas]');
      if (measSelect) {
        measSelect.innerHTML = '';
        matchingMeas.forEach(function(item) {
          var opt = document.createElement('option');
          opt.value = item.idx;
          opt.textContent = item.profile.name + (item.profile.isDefault ? ' ★' : '');
          measSelect.appendChild(opt);
        });
        /* Auto-select default */
        var defaultItem = matchingMeas.find(function(item) { return item.profile.isDefault; });
        if (defaultItem) measSelect.value = defaultItem.idx;
      }

      /* Populate style dropdown */
      var styleSelect = bar.querySelector('[data-qo-style]');
      if (styleSelect) {
        /* Always keep "As Shown" as first option */
        styleSelect.innerHTML = '<option value="_as_shown">As Shown</option>';

        if (!isBasic) {
          /* Add matching style profiles */
          styleProfiles.forEach(function(p, i) {
            if (p.garmentType === garmentType ||
                (garmentType === 'suit' && (p.garmentType === 'jacket' || p.garmentType === 'trouser'))) {
              var opt = document.createElement('option');
              opt.value = i;
              opt.textContent = p.name;
              styleSelect.appendChild(opt);
            }
          });
        }

        /* If basic or no style profiles beyond "As Shown", hide style dropdown */
        if (styleSelect.options.length <= 1) {
          styleSelect.style.display = 'none';
          if (measSelect) measSelect.style.flex = '1';
        }
      }

      /* Show the bar */
      bar.style.display = '';

      /* Add to cart handler */
      var addBtn = bar.querySelector('[data-qo-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          handleAddToCart(bar, addBtn, measProfiles, styleProfiles);
        });
      }

      /* Prevent clicks on selects/buttons from navigating to product page */
      bar.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); });
    });
  }

  function handleAddToCart(bar, btn, measProfiles, styleProfiles) {
    var variantId = parseInt(bar.dataset.variantId, 10);
    var productTitle = bar.dataset.productTitle;
    var garmentType = bar.dataset.garmentType;

    var measSelect = bar.querySelector('[data-qo-meas]');
    var styleSelect = bar.querySelector('[data-qo-style]');

    /* Build properties */
    var props = {
      'Style': 'As Shown',
      '_quick_order': 'true'
    };

    /* Measurement profile */
    if (measSelect && measSelect.value !== '') {
      var measProfile = measProfiles[parseInt(measSelect.value, 10)];
      if (measProfile) {
        props['_measurement_profile'] = measProfile.name;
        props['Measurement Method'] = 'Saved Profile: ' + measProfile.name;
        var measProps = buildMeasProperties(measProfile);
        Object.keys(measProps).forEach(function(k) { props[k] = measProps[k]; });
      }
    }

    /* Style profile */
    if (styleSelect && styleSelect.value !== '_as_shown' && styleSelect.value !== '') {
      var styleProfile = styleProfiles[parseInt(styleSelect.value, 10)];
      if (styleProfile) {
        props['Style'] = 'Customized (Profile: ' + styleProfile.name + ')';
        props['_style_profile'] = styleProfile.name;
        var styleProps = buildStyleProperties(styleProfile);
        Object.keys(styleProps).forEach(function(k) { props[k] = styleProps[k]; });
      }
    }

    /* Visual feedback */
    btn.classList.add('qo-bar__add--adding');
    btn.textContent = 'Adding…';

    /* AJAX add to cart */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: props
        }]
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.classList.remove('qo-bar__add--adding');
      btn.classList.add('qo-bar__add--done');
      btn.textContent = '✓ Added';

      /* Update cart count in header (filtered — exclude surcharges/shipping) */
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var count = 0;
        (cart.items || []).forEach(function(i) {
          var tp = (i.product_type || '').toLowerCase();
          var tt = (i.title || '').toLowerCase();
          if (tp === 'surcharge' || tp === 'shipping' || tt === 'shipping' ||
              tt.indexOf('shipping:') >= 0 || tt.indexOf('shipping -') >= 0) return;
          count += i.quantity;
        });
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = count;
          el.style.display = count > 0 ? '' : 'none';
        });
      });

      /* Reset button after 2s */
      setTimeout(function() {
        btn.classList.remove('qo-bar__add--done');
        btn.textContent = (window.LuxireI18n && LuxireI18n.addToCart) || 'Add to Cart';
      }, 2000);
    })
    .catch(function(err) {
      btn.classList.remove('qo-bar__add--adding');
      btn.textContent = 'Error — try again';
      setTimeout(function() { btn.textContent = (window.LuxireI18n && LuxireI18n.addToCart) || 'Add to Cart'; }, 2000);
    });
  }

  /* Init on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
